import { ITrialClass } from '@wot/typings';
import { BiSort } from 'react-icons/bi';
import { Table, TableBody, TableHeading, TableHeadingCol, TableRow } from '../../../../components/Table';
import TableRowItem from './TableRowItem';
import { Sorting } from '..';

interface Props {
  data: ITrialClass[];
  actionRequired?: boolean;
  handleSort: (key: Sorting) => void;
}

export default function TableContainer({ data, actionRequired = false, handleSort }: Props) {
  return (
    <Table>
      <TableHeading>
        <TableRow>
          <TableHeadingCol
            label="DATE"
            component={
              <div className="flex items-center">
                <p className="">DATE</p>
                <BiSort className="text-sm" />
              </div>
            }
            onClick={() => handleSort('createdAt')}
          />
          <TableHeadingCol label="Class ID" />
          <TableHeadingCol
            label="NAME"
            component={
              <div className="flex items-center">
                <p className="">NAME</p>
                <BiSort className="text-sm" />
              </div>
            }
            onClick={() => handleSort('name')}
          />
          {/* <TableHeadingCol label="EMAIL" /> */}
          <TableHeadingCol label="Subject" />
          <TableHeadingCol
            label="Scheduled Time"
            component={
              <div className="flex items-center">
                <p className="">Scheduled Time</p>
                <BiSort className="text-sm" />
              </div>
            }
            onClick={() => handleSort('scheduledTime')}
          />
          <TableHeadingCol label="TUTOR" />
          <TableHeadingCol label="TYPE" />
          <TableHeadingCol label="STATUS" />
          <TableHeadingCol label={actionRequired ? 'Action Required' : ''} />
        </TableRow>
      </TableHeading>
      <TableBody>
        {data.map((session) => (
          <TableRow key={session._id}>
            <TableRowItem session={session} actionRequired={actionRequired} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
